import StudentExamsList from './StudentExamsList';

export default StudentExamsList;
